import I18n from "../../../../../../../localization/I18n";
import { GridSideModalTitle } from "../../../../utils/GridModalUtils";
import { ImpactActionSidebar } from "./ImpactActionSidebar_view";

export const IMPACT_ACTIONS_SIDEBAR_MODAL_CONFIG = (
  organisationId: number,
  projectId: number,
  impact: FP.Entities.IImpact
) => {
  return {
    showClose: true,
    title: <GridSideModalTitle name={impact.name} field={I18n.t("phrases.actions")} />,
    content: <ImpactActionSidebar projectId={projectId} impactId={impact.id} impact={impact} />
  };
};
